import { createRoutine } from 'redux-saga-routines'
import { put, call, takeLatest, fork, select } from '@redux-saga/core/effects'
import * as bpService from 'services/BpService'
import * as fileService from 'services/fileService'
import { pathOr } from 'ramda'
import { toast } from 'react-toastify'
import { getApiErrors } from 'utils/errors'
import { PRIVATE_PATHS, redirect } from 'utils/paths'
import { fetchBpUnitsRoutine } from 'ducks/units/actions'
import { createBpRoutine } from 'features/createBp/ducks/actions'
import { fetchFavouritesRoutine } from 'features/bpList/ducks/actions'
import { fetchLastSearchedBpsRoutine } from 'features/dashboard/ducks/actions'
import { getInvitationsListForBpRoutine } from 'features/accessControl/ducks/actions'

export const fetchBpRoutine = createRoutine('FETCH_BP')

// computeGuruMessagesRoutine removed — replaced by ducks/guruChat

export const searchLocalFilesRoutine = createRoutine('SEARCH_LOCAL_FILES')
export const addBuildingTypeToBpRoutine = createRoutine(
  'ADD_BUILDING_TYPE_TO_BP'
)
export const markBpAsSearchedRoutine = createRoutine('MARK_BP_AS_SEARCHED')
export const markFileAsSearchedRoutine = createRoutine('MARK_FILE_AS_SEARCHED')
export const markBpAsViewedRoutine = createRoutine('MARK_BP_AS_VIEWED')
export const addToFavouritesRoutine = createRoutine('ADD_TO_FAVOURITES')
export const removeFromFavouritesRoutine = createRoutine(
  'REMOVE_FROM_FAVOURITES'
)
export const clearSelectedBpRoutine = createRoutine('CLEAR_SELECTED_BP')
export const getUserRelationToBpRoutine = createRoutine(
  'GET_USER_RELATION_TO_BP'
)
export const getBpConnectedUsersRoutine = createRoutine(
  'GET_BP_CONNECTED_USERS'
)
export const getBpConnectedUsersByEmailRoutine = createRoutine(
  'GET_BP_CONNECTED_USERS_BY_EMAIL'
)
export const getUsersByEmailRoutine = createRoutine('GET_USERS')
export const clearConnectedUsersRoutine = createRoutine('CLEAR_CONNECTED_USERS')
export const clearUsersFoundByEmailRoutine = createRoutine('CLEAR_FOUND_USERS')
export const bulkShareFilesRoutine = createRoutine('BULK_SHARE_FILES')
export const fetchExternalSharedFilesRoutine = createRoutine('FETCH_EXTERNAL_SHARED_FILES');
export const bulkUnsharedFilesRoutine = createRoutine('BULK_UNSHARE_FILES')
export const fetchInternalSharedUsersRoutine = createRoutine('FETCH_INTERNAL_SHARED_USERS')
export const fetchSharedUsersForFilesRoutine = createRoutine('FETCH_SHARED_USERS_FOR_FILES')
export const bpPeopleCountRoutine = createRoutine('BP_PEOPLE_COUNT')
export const unshareAllFilesForEmailRoutine = createRoutine('BUILDING_PASSPORT/FILES/UNSHARE_ALL_FOR_EMAIL')
export const logExternalPreviewRoutine = createRoutine('EXTERNAL_ACCESS/LOG_PREVIEW')
export const logExternalDownloadRoutine = createRoutine('EXTERNAL_ACCESS/LOG_DOWNLOAD')
export const checkUserByEmailRoutine = createRoutine('CHECK_USER_BY_EMAIL')
export const bulkEditFilesRoutine = createRoutine('BULK_EDIT_FILES')
export const accessControlAssignRoutine   = createRoutine('ACCESS_CONTROL/ASSIGN_WITH_APPROVAL');
export const accessControlApproveRoutine  = createRoutine('ACCESS_CONTROL/INVITATION_APPROVE');
export const accessControlDenyRoutine     = createRoutine('ACCESS_CONTROL/INVITATION_DENY');
export const accessControlFetchRoutine    = createRoutine('FETCH_INVITATIONS');

export const unitAccessFetchRequestsRoutine = createRoutine('UNIT_ACCESS/FETCH_REQUESTS')
export const unitAccessFetchInvitationsRoutine = createRoutine('UNIT_ACCESS/FETCH_INVITATIONS')
export const unitAccessFetchRevokedRoutine = createRoutine('UNIT_ACCESS/FETCH_REVOKED')
export const unitAccessRevokeRoutine = createRoutine('UNIT_ACCESS/REVOKE')
export const unitAccessApproveInvitationRoutine = createRoutine('UNIT_ACCESS_APPROVE_INVITATION');
export const unitAccessApproveRequestRoutine = createRoutine('UNIT_ACCESS_APPROVE_REQUEST');
export const unitAccessDenyRoutine = createRoutine('UNIT_ACCESS/DENY')
export const unitAccessReactivateRoutine = createRoutine('UNIT_ACCESS/REACTIVATE');
export const unitAccessDeleteRoutine = createRoutine('UNIT_ACCESS/DELETE');
export const unitAccessFetchUnitRoutine = createRoutine('UNIT_ACCESS/FETCH_UNIT')
function* addBuildingTypeToBp({ payload }) {
  const { isWizard } = payload
  yield put(addBuildingTypeToBpRoutine.request())
  try {
    const { data } = yield call(bpService.addBuildingTypeToBp, payload)
    yield put(addBuildingTypeToBpRoutine.success(data.data))
    toast.success('Building type has been added')
    if (isWizard) {
      yield put(createBpRoutine.success(data.data))
    } else {
      yield put(fetchBpRoutine({ id: payload.bpId }))
    }
    yield put(fetchBpUnitsRoutine({ bpId: payload.bpId }))
  } catch (error) {
    yield put(addBuildingTypeToBpRoutine.failure(error))
  }
}

function* fetchExternalSharedFiles({ payload }) {
  yield put(fetchExternalSharedFilesRoutine.request())
  try {
    const { fileShareId } = payload

    const { data } = yield call(fileService.fetchExternalSharedFiles, fileShareId)

    yield put(fetchExternalSharedFilesRoutine.success(data.data))
  } catch (error) {
    yield put(fetchExternalSharedFilesRoutine.failure(error))
    toast.error(getApiErrors(error))
  }
}

function* logExternalPreview({ payload }) {
  try {
    yield call(fileService.logExternalPreview, payload)
    yield put(logExternalPreviewRoutine.success())
  } catch (error) {
    yield put(logExternalPreviewRoutine.failure(error))
  }
}

function* logExternalDownload({ payload }) {
  try {
    yield call(fileService.logExternalDownload, payload)
    yield put(logExternalDownloadRoutine.success())
  } catch (error) {
    yield put(logExternalDownloadRoutine.failure(error))
  }
}

function* fetchInternalSharedUsers({ payload }) {
  yield put(fetchInternalSharedUsersRoutine.request())
  try {
    const { data } = yield call(fileService.fetchInternalSharedUsers, payload)
    yield put(fetchInternalSharedUsersRoutine.success(data.data))
  } catch (error) {
    yield put(fetchInternalSharedUsersRoutine.failure(error))
  }
}

function* fetchSharedUsersForFiles({ payload }) {
  yield put(fetchSharedUsersForFilesRoutine.request())
  try {
    const { data } = yield call(fileService.fetchSharedUsersForFiles, payload)
    yield put(fetchSharedUsersForFilesRoutine.success(data))
  } catch (error) {
    toast.error(getApiErrors(error))
    yield put(fetchSharedUsersForFilesRoutine.failure(error))
  }
}

function* addToFavourites({ payload }) {
  yield put(addToFavouritesRoutine.request())
  try {
    yield call(bpService.addToFavourites, payload)
    yield put(addToFavouritesRoutine.success(payload.bpId))
    yield put(fetchFavouritesRoutine({ page: 1 }))
    toast.success('Building Passport has been added to favourites')
  } catch (error) {
    yield put(addToFavouritesRoutine.failure(error))
  }
}

function* removeFromFavourites({ payload }) {
  yield put(removeFromFavouritesRoutine.request())
  try {
    yield call(bpService.removeFromFavourites, payload)
    yield put(removeFromFavouritesRoutine.success(payload.bpId))
    yield put(fetchFavouritesRoutine({ page: 1 }))
    toast.success('Building Passport has been removed from favourites')
  } catch (error) {
    yield put(removeFromFavouritesRoutine.failure(error))
  }
}

function* markBpAsSearched({ payload }) {
  yield put(markBpAsSearchedRoutine.request())
  try {
    yield call(bpService.markAsSearched, payload)
    yield put(markBpAsSearchedRoutine.success())
    yield put(fetchLastSearchedBpsRoutine())
  } catch (error) {
    yield put(markBpAsSearchedRoutine.failure(error))
  }
}

function* markFileAsSearched({ payload }) {
  yield put(markFileAsSearchedRoutine.request())
  try {
    yield call(bpService.markFileAsSearched, payload)
    yield put(markFileAsSearchedRoutine.success())
  } catch (error) {
    yield put(markFileAsSearchedRoutine.failure(error))
  }
}

let currentSearchController = null

function* searchLocalFiles({ payload }) {
  // Abort any in-flight search request before starting a new one
  if (currentSearchController) currentSearchController.abort()
  currentSearchController = new AbortController()
  const signal = currentSearchController.signal

  const { query, bpId, exactMatch, uploaderIds, fileTypeIds, fileCategoryIds, fileTagIds, searchMode, unlimited, customViewId, viewableByUserId, onComplete } = payload

  yield put(searchLocalFilesRoutine.request())
  try {
    const { data } = yield call(fileService.searchLocalFiles, {
      query,
      bpId,
      exactMatch,
      uploaderIds,
      fileTypeIds,
      fileCategoryIds,
      tagIds: fileTagIds, // Service expects tagIds parameter
      searchMode, // Pass search mode ('name' or 'content')
      unlimited,
      customViewId,
      viewableByUserId
    }, signal)

    if (signal.aborted) return

    // API returns full file objects from FileResource::collection
    const results = Array.isArray(data.data) ? data.data : []
    const truncated = !!(data.meta && data.meta.truncated)

    yield put(searchLocalFilesRoutine.success({ results, truncated }))

    if (typeof onComplete === 'function') {
      yield call(onComplete)
    }
  } catch (error) {
    // Silently ignore aborted requests
    if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED' || signal.aborted) return

    yield put(searchLocalFilesRoutine.failure(error))

    if (typeof onComplete === 'function') {
      yield call(onComplete)
    }
  }
}
function* markBpAsViewed({ payload }) {
  yield put(markBpAsViewedRoutine.request())
  try {
    yield call(bpService.markAsViewed, payload)
    yield put(markBpAsViewedRoutine.success())
  } catch (error) {
    yield put(markBpAsViewedRoutine.failure(error))
  }
}

function* fetchBp({ payload }) {
  yield put(fetchBpRoutine.request())
  const { id, callback } = payload
  try {
    const result = yield call(bpService.fetchBp, id)
    yield put(fetchBpRoutine.success(result.data.data))
    typeof callback === 'function' && callback()
  } catch (error) {
    const status = pathOr(0, ['response', 'status'], error)
    if (status === 403) {
      const message = getApiErrors(error)
      if (message?.trim()) toast.error(message)
      redirect(PRIVATE_PATHS.bpList)
    } else if (status === 404) {
      redirect(PRIVATE_PATHS.bpList)
    }
    yield put(fetchBpRoutine.failure(error))
  }
}

function* getBpConnectedUsers({ payload }) {
  yield put(getBpConnectedUsersRoutine.request())
  try {
    if (payload.length >= 3) {
      const result = yield call(bpService.getBpConnectedUsers, payload)
      yield put(getBpConnectedUsersRoutine.success(result.data.data))
    } else {
      yield put(getBpConnectedUsersRoutine.success([]))
    }
  } catch (error) {
    yield put(getBpConnectedUsersRoutine.failure(error))
  }
}

function* getBpConnectedUsersByEmail({ payload }) {
  yield put(getBpConnectedUsersByEmailRoutine.request())
  try {
    const { data } = yield call(
      bpService.getBpConnectedUsersByEmail,
      payload.replace('+', '%2B').toLowerCase()
    )
    yield put(getBpConnectedUsersByEmailRoutine.success(data.data))
  } catch (error) {
    yield put(getBpConnectedUsersByEmailRoutine.failure(error))
  }
}

function* clearConnectedUsers() {
  yield put(clearConnectedUsersRoutine.success())
}

function* getUsersByEmail({ payload }) {
  const { email, type } = payload
  const codedEmail = email.replace('+', '%2B').toLowerCase()
  yield put(getUsersByEmailRoutine.request())
  try {
    if (payload.email.length >= 3) {
      const result = yield call(bpService.getUsers, codedEmail)
      yield put(
        getUsersByEmailRoutine.success({ data: result.data.data, type })
      )
    } else {
      yield put(getUsersByEmailRoutine.success([]))
    }
  } catch (error) {
    yield put(getUsersByEmailRoutine.failure(error))
  }
}

function* clearUsersFoudByEmail() {
  yield put(clearUsersFoundByEmailRoutine.success())
}

function* getUserRelationToBp({ payload }) {
  yield put(getUserRelationToBpRoutine.request())
  try {
    const { data } = yield call(bpService.getUserRelationToBp, payload)
    yield put(getUserRelationToBpRoutine.success(data.data.roles))
  } catch (error) {
    getApiErrors(error)?.trim() && toast.error(getApiErrors(error))
    yield put(getUserRelationToBpRoutine.failure(error))
  }
}

function* clearSelectedBp() {
  yield put(clearSelectedBpRoutine.success())
}

const selectLoadedBpFileIds = state => (state.files?.bpFilesList || []).map(f => f.id)

export function* refreshSharedUsersForLoadedFiles() {
  const fileIds = yield select(selectLoadedBpFileIds)
  if (fileIds.length) yield put(fetchSharedUsersForFilesRoutine.trigger(fileIds))
}

export function* bulkShareFiles({ payload }) {
  yield put(bulkShareFilesRoutine.request())
  try {
    const { data } = yield call(fileService.bulkShareFiles, payload)

    yield put(bulkShareFilesRoutine.success({
      sharedCount: data.sharedCount || 0,
      warning: data.warning || [],
      fileIds: payload?.fileIds || [],
      sharedWithUnits: Array.isArray(payload?.units) && payload.units.length > 0
    }))
    yield* refreshSharedUsersForLoadedFiles()

  } catch (error) {
    getApiErrors(error)?.trim() && toast.error(getApiErrors(error))
    yield put(bulkShareFilesRoutine.failure(error))
  }
}

export function* bulkUnsharedFiles({ payload }) {
  yield put(bulkUnsharedFilesRoutine.request())
  try {
    const { data } = yield call(fileService.bulkUnsharedFiles, payload)
    if (data.message) toast.success(data.message)
    yield put(bulkUnsharedFilesRoutine.success())
    yield* refreshSharedUsersForLoadedFiles()
  } catch (error) {
    toast.error(getApiErrors(error))
    yield put(bulkUnsharedFilesRoutine.failure(error))
  }
}

function* unshareAllFilesForEmail({ payload }) {
  yield put(unshareAllFilesForEmailRoutine.request())
  try {
    const { data } = yield call(fileService.bulkUnsharedFiles, payload)
    if (data.message) toast.success(data.message)
    yield put(unshareAllFilesForEmailRoutine.success())
  } catch (error) {
    toast.error(getApiErrors(error))
    yield put(unshareAllFilesForEmailRoutine.failure(error))
  }
}

function* checkUserByEmail({ payload }) {
  try {
    yield put(checkUserByEmailRoutine.request())
    const { email, bpId } = payload
    const result = yield call(fileService.checkUserByEmail, email, bpId)
    yield put(checkUserByEmailRoutine.success(result.data))
  } catch (error) {
    yield put(checkUserByEmailRoutine.failure(error))
  }
}
function* handleBulkEditFiles({ payload }) {
  try {
    const { fileIds, updates, onSuccess } = payload
    const res = yield call(fileService.bulkEditFiles, { fileIds, updates })
    yield put({
      type: bulkEditFilesRoutine.SUCCESS,
      payload: null,
      meta: { fileIds, updates }
    })

    toast.success(res?.data?.message || 'Files updated successfully')

    if (typeof onSuccess === 'function') {
      try {
        yield call(onSuccess)
      } catch (e) {
        console.error('onSuccess error:', e)
      }
    }
  } catch (e) {
    console.error('bulkEditFiles failed:', e)
    toast.error(getApiErrors(e) || 'Something went wrong')
    if (typeof payload.onFailure === 'function') {
      try {
        yield call(payload.onFailure)
      } catch (err) {
        console.error('onFailure error:', err)
      }
    }
    yield put(bulkEditFilesRoutine.failure(e))
  }
}
export function* accessControlAssignWorker({ payload }) {
  const { bpId, relation_type, user_id, email, first_name, last_name, phone_number, expires_at, note } = payload;
  try {
    yield put(accessControlAssignRoutine.request());
    const { data } = yield call(
      bpService.assignUserWithApproval,
      {
        bpId,
        body: { relation_type, user_id, email, first_name, last_name, phone_number, expires_at, note }
      }
    );
    yield put(accessControlAssignRoutine.success({ ...(data?.data || data), bpId }));

    const status = (data?.data || data)?.status || 'pending';
    if (status === 'approved') {
      toast.success('Access granted.');
    } else {
      toast.success('Request sent. Owners will review.');
    }

    yield put(accessControlFetchRoutine.trigger({ bpId }));
    yield put(fetchBpRoutine({ id: bpId }));
    yield put(getInvitationsListForBpRoutine(bpId));
  } catch (error) {
    yield put(accessControlAssignRoutine.failure(error));
    const msg = getApiErrors(error) || (error?.status === 409
      ? 'A pending invitation already exists for this user/email.'
      : 'Could not send the invitation.');
    toast.error(msg);
  }
}

export function* accessControlApproveWorker({ payload }) {
  const { bpId, invitationId } = payload;
  try {
    yield put(accessControlApproveRoutine.request());
    yield call(bpService.approveUserInvitation, { bpId, invitationId });

    yield put(accessControlApproveRoutine.success({ invitationId, bpId }));

    yield put(fetchBpRoutine({ id: bpId }));

    yield put(accessControlFetchRoutine.trigger({ bpId }));
    toast.success('Invitation approved');
    if (typeof payload.onSuccess === 'function') payload.onSuccess();
  } catch (error) {
    yield put(accessControlApproveRoutine.failure(error));
    toast.error(getApiErrors(error) || 'Could not approve invitation');
  }
}

export function* accessControlDenyWorker({ payload }) {
  const { bpId, invitationId } = payload;
  try {
    yield put(accessControlDenyRoutine.request());
    yield call(bpService.denyUserInvitation, { bpId, invitationId });

    yield put(accessControlDenyRoutine.success({ invitationId, bpId }));

    yield put(fetchBpRoutine({ id: bpId }));

    yield put(accessControlFetchRoutine.trigger({ bpId }));
    toast.success('Invitation denied');
    if (typeof payload.onSuccess === 'function') payload.onSuccess();
  } catch (error) {
    yield put(accessControlDenyRoutine.failure(error));
    toast.error(getApiErrors(error) || 'Could not deny invitation');
  }
}

// WATCHERS

export function* markBpAsSearchedWatcher() {
  yield takeLatest(markBpAsSearchedRoutine.TRIGGER, markBpAsSearched)
}

export function* markFileAsSearchedWatcher() {
  yield takeLatest(markFileAsSearchedRoutine.TRIGGER, markFileAsSearched)
}
export function* fetchBpWatcher() {
  yield takeLatest(fetchBpRoutine.TRIGGER, fetchBp)
}

export function* getBpConnectedUsersWatcher() {
  yield takeLatest(getBpConnectedUsersRoutine.TRIGGER, getBpConnectedUsers)
}

export function* getBpConnectedUsersByEmailWatcher() {
  yield takeLatest(
    getBpConnectedUsersByEmailRoutine.TRIGGER,
    getBpConnectedUsersByEmail
  )
}

export function* searchLocalFilesWatcher() {
  yield takeLatest(searchLocalFilesRoutine.TRIGGER, searchLocalFiles)
}

export function* addToFavouritesWatcher() {
  yield takeLatest(addToFavouritesRoutine.TRIGGER, addToFavourites)
}

export function* removeFromFavouritesWatcher() {
  yield takeLatest(removeFromFavouritesRoutine.TRIGGER, removeFromFavourites)
}

export function* markBpAsViewedWatcher() {
  yield takeLatest(markBpAsViewedRoutine.TRIGGER, markBpAsViewed)
}

export function* getUsersByEmailWatcher() {
  yield takeLatest(getUsersByEmailRoutine.TRIGGER, getUsersByEmail)
}

export function* clearConnectedUsersWatcher() {
  yield takeLatest(clearConnectedUsersRoutine.TRIGGER, clearConnectedUsers)
}

export function* clearUsersFoudByEmailWatcher() {
  yield takeLatest(clearUsersFoundByEmailRoutine.TRIGGER, clearUsersFoudByEmail)
}

export function* addBuildingTypeToBpWatcher() {
  yield takeLatest(addBuildingTypeToBpRoutine.TRIGGER, addBuildingTypeToBp)
}

export function* clearSelectedBpWatcher() {
  yield takeLatest(clearSelectedBpRoutine.TRIGGER, clearSelectedBp)
}

export function* getUserRelationToBpWatcher() {
  yield takeLatest(getUserRelationToBpRoutine.TRIGGER, getUserRelationToBp)
}

export function* bulkShareFilesWatcher() {
  yield takeLatest(bulkShareFilesRoutine.TRIGGER, bulkShareFiles)
}

export function* fetchExternalSharedFilesWatcher() {
  yield takeLatest(fetchExternalSharedFilesRoutine.TRIGGER, fetchExternalSharedFiles);
}

export function* bulkUnsharedFilesWatcher() {
  yield takeLatest(bulkUnsharedFilesRoutine.TRIGGER, bulkUnsharedFiles)
}

export function* fetchInternalSharedUsersWatcher() {
  yield takeLatest(fetchInternalSharedUsersRoutine.TRIGGER, fetchInternalSharedUsers)
}

export function* fetchSharedUsersForFilesWatcher() {
  yield takeLatest(fetchSharedUsersForFilesRoutine.TRIGGER, fetchSharedUsersForFiles)
}

export function* unshareAllFilesForEmailWatcher() {
  yield takeLatest(unshareAllFilesForEmailRoutine.TRIGGER, unshareAllFilesForEmail)
}
export function* logExternalPreviewWatcher() {
    yield takeLatest(logExternalPreviewRoutine.TRIGGER, logExternalPreview)
}
export function* logExternalDownloadWatcher() {
    yield takeLatest(logExternalDownloadRoutine.TRIGGER, logExternalDownload)
}
export function* checkUserByEmailWatcher() {
  yield takeLatest(checkUserByEmailRoutine.TRIGGER, checkUserByEmail)
}

export function* filesEditWatcher() {
  yield takeLatest(bulkEditFilesRoutine.TRIGGER, handleBulkEditFiles)
}

export function* accessControlAssignWatcher() {
  yield takeLatest(accessControlAssignRoutine.TRIGGER, accessControlAssignWorker);
}
export function* accessControlApproveWatcher() {
  yield takeLatest(accessControlApproveRoutine.TRIGGER, accessControlApproveWorker);
}
export function* accessControlDenyWatcher() {
  yield takeLatest(accessControlDenyRoutine.TRIGGER, accessControlDenyWorker);
}

// SAGAS
export const bpDetailsSagas = [
  fork(markBpAsSearchedWatcher),
  fork(markFileAsSearchedWatcher),
  fork(searchLocalFilesWatcher),
  fork(fetchBpWatcher),
  fork(getBpConnectedUsersWatcher),
  fork(getBpConnectedUsersByEmailWatcher),
  fork(addToFavouritesWatcher),
  fork(removeFromFavouritesWatcher),
  fork(markBpAsViewedWatcher),
  fork(getUsersByEmailWatcher),
  fork(clearConnectedUsersWatcher),
  fork(clearUsersFoudByEmailWatcher),
  fork(clearUsersFoudByEmailWatcher),
  fork(addBuildingTypeToBpWatcher),
  fork(clearSelectedBpWatcher),
  fork(getUserRelationToBpWatcher),
  fork(bulkShareFilesWatcher),
  fork(fetchExternalSharedFilesWatcher),
  fork(bulkUnsharedFilesWatcher),
  fork(fetchInternalSharedUsersWatcher),
  fork(fetchSharedUsersForFilesWatcher),
  fork(unshareAllFilesForEmailWatcher),
  fork(logExternalPreviewWatcher),
  fork(logExternalDownloadWatcher),
  fork(checkUserByEmailWatcher),
  fork(filesEditWatcher),
  fork(accessControlAssignWatcher),
  fork(accessControlApproveWatcher),
  fork(accessControlDenyWatcher),
]
